import type { SupportedLanguage } from "@ryde/shared";

import type { IErrorBoundaryTexts } from "./error-boundary.models";

/**
 * Bundled (not loaded from the translations API) so the fallback still renders
 * in the right language when the failure is in i18n / network itself.
 */
export const ERROR_BOUNDARY_TEXTS: Record<
  SupportedLanguage,
  IErrorBoundaryTexts
> = {
  en: {
    title: "Something went wrong",
    subtitle:
      "We're sorry — the page hit an unexpected error. Reload to continue, or open the details to copy them for support.",
    openDetails: "Open details",
    closeDetails: "Close details",
    copyDetails: "Copy error details",
    reloadPage: "Reload page",
    reportCopied: "Error details copied — you can paste them into chat",
    copyFailed:
      "Could not copy automatically — open details and select the text",
    languageSwitcher: "Language",
    languageEnglish: "English",
    languageHebrew: "עברית",
  },
  he: {
    title: "משהו השתבש",
    subtitle:
      "מצטערים — בדף אירעה שגיאה בלתי צפויה. אפשר לטעון מחדש את הדף, או לפתוח את הפרטים ולהעתיק אותם לתמיכה.",
    openDetails: "פתיחת פרטים",
    closeDetails: "סגירת פרטים",
    copyDetails: "העתקת פרטי השגיאה",
    reloadPage: "טעינה מחדש",
    reportCopied: "פרטי השגיאה הועתקו — אפשר להדביק אותם בצ'אט",
    copyFailed: "לא ניתן להעתיק אוטומטית — פתחו את הפרטים ובחרו את הטקסט",
    languageSwitcher: "שפה",
    languageEnglish: "English",
    languageHebrew: "עברית",
  },
};
